import { environment } from 'src/environments/environment';

export const base   = environment.base;
export const baseV2 = base.replace('/api/v1', '/api/v2');

export const api = {
  invite: base + '/startup/getPromoText/', //GET
  Login: base + '/user/mobile/login', //POST
  adminLogin: base + '/admin/login', //POST
  validateAdminOtp: base + '/admin/otp', //POST
  /** Full ADMIN only (not DELEGATION_ADMIN). Append ?dbName=clocrus etc. */
  delegationAdminList: base + '/admin/delegation-admin/list', // GET
  delegationAdminAssign: base + '/admin/delegation-admin/assign', // POST
  delegationAdminRevoke: base + '/admin/delegation-admin/revoke', // POST
  /** DELEGATION_ADMIN or ADMIN — GET .../details/:userId?dbName= ; PUT .../details?dbName= */
  delegationAdminDetails: base + '/admin/delegation-admin/details', // GET .../:id | PUT (no id)
  /** Lokblok — full ADMIN. POST `{ targetUserId, newState }`; GET delegates for user. */
  lokblokSetUserAccountStatus: base + '/admin/delegation-admin/lokblok/set-user-account-status', // POST ?dbName=
  lokblokDelegates: base + '/admin/delegation-admin/lokblok/delegates', // GET .../delegates/:targetUserId?dbName=
  /** POST — client sends serialNumber + adminInfo; backend CreateUser + RegisterToughkey + AddRole 9 */
  lokblokCreateRecoveryAdminUser:
    base + '/admin/delegation-admin/lokblok/create-recovery-admin-user', // POST ?dbName=
  /** GET — Toughbox roles / adminRecord status for logged-in delegation admin */
  lokblokGetAppAdminInfo: base + '/admin/delegation-admin/lokblok/get-app-admin-info', // POST ?dbName=
  /** POST — Toughbox GetSecretStatus preflight before delegate approve (delegation_sample test 22). */
  lokblokGetSecretStatus: base + '/admin/delegation-admin/lokblok/get-secret-status', // POST ?dbName=
  /** DELEGATION_ADMIN or ADMIN — GET ?dbName=&status=&limit=&offset= */
  delegationAdminDelegate: base + '/admin/delegation-admin/delegate', // GET
  /** DELEGATION_ADMIN or ADMIN — POST ?dbName= approve delegate recovery (test 22) */
  delegationAdminDelegateInitiate: base + '/admin/delegation-admin/delegate/initiate', // POST
  googleLogin: base + '/user/social',
  ResendOtp: base + '/user/resendOTP', //POST
  ValidateOtp: base + '/user/mobile/otp', //POST
  ValidateCaretakerOtp: base + '/user/sso/otp', //POST
  RegisterUser: base + '/legacy/register', //POST
  /** TOD / owner deceased — routes mounted at `/api/v1/legacy` */
  todOwnerDeceased: base + '/legacy/tod/owner-deceased', // POST ?dbName=
  todRequests: base + '/legacy/tod/requests', // GET list; GET :id detail; append /:id/objections | /:id/documents
  /** Admin / ML TOD — requires ADMIN or DELEGATION_ADMIN; ?dbName= */
  adminTodRequests: base + '/admin/tod/requests', // POST .../requests/:id/...
  /**
   * Canonical Phase 7 — participant routes under /legacy (JWT session).
   * GET event; POST candidate accept/reject; POST toughkey receipt; trustee-kyc; recovery; ra-decision.
   */
  legacyDelegationEvents: base + '/legacy/delegation/events', // GET|POST .../events/:eventId/...
  /**
   * Canonical Phase 7 — full ADMIN only under /admin.
   * start from TOD request; admin-kyc; shipment; delivery; authorization; access-window; candidate-removal/retry.
   */
  adminTodDelegation: base + '/admin/tod/delegation', // POST .../requests/:id/start | .../events/:id/...
  userVerify: base + '/legacy/userVerify', //POST
  ForgotPassword: base + '/user/forgotPassword', //POST
  CountriesList: base + '/startup/getAllCountries', //GET
  ResetPassword: base + '/user/password/reset', //POST
  UserProfile: base + '/user/details', //GET
  kycbilling: base +'/user/kyc/verification-status',
  uploadUserPicture: base + '/user/profilePic', //POST
  deleteUserPicture: base + '/user/deleteProfilePic', //DELETE
  ChangePassword: base + '/user/verifyPassword', // POST
  SavePassword: base + '/user/savePassword', //POST
  GetStates: base + '/startup/getAllStates/', //GET
  change2FaSetting: base + '/user/2faSettings', //PUT
  careTaker: base + '/caretaker/', //POST
  updateUserProfile: base + `/user/`, //PUT
  VerifyResetUrl: base + '/user/verifyResetUrl/', //GET
  businessVerifyResetUrl: base + '/business/verifyAssociateRegistrationURL/', //GET
  removeToken: base + '/user/removeToken', //POST
  getKycToken: base + '/user/kyc/token', //GET
  getKycLegacyToken: base + '/user/kyc/legacy/token', //GET
  getLegacyKycSession: base + '/legacy/kyc/session/', //GET
  updateRaKycStatus: base + '/recovery-agent/raKYC', //PUT
  getAlerts: base + '/user/alerts', //GET PUT
  deleteAlert: base + '/user/alerts', // DELET
  updateKYC: base + '/user/kycUpdate', //POST
  userKYCUpdate: base + '/user/userKYCUpdate', //POST - Scytale KYC update
  updateUserKycStatus: base + '/user/recovery/kycUpdate', //POST
  initiateRecovery: base + '/recovery/initiate',
  updateInitiateRecoverKyc: base + '/user/initiate/kycUpdate', //POST
  getKycDetails: base + '/user/kyc/details', //GET
  guardianOnBoarding: base + '/user/guardianonboarding', //PUT
  userOnBoarding: base + '/user/useronboarding', //PUT
  auditTrail: base + '/reports/myActivity', //POST
  faq: base + '/user/crypto/faq', //GET
  /** Support request submission (multipart). */
  userSupport: base + '/user/support', //POST ?dbName=clocrus
  businessSupport: base + '/business/support', //POST
  //Will APIs
  saveWill: base + '/cryptowill', //POST
  updateWill: base + '/cryptowill', //PUT
  saveExecutors: base + '/cryptowill/executor/bulk', //POST
  getWillList: base + '/cryptowill', //GET
  finalizeWill: base + '/cryptowill/generateWill', //GET

  //recovery agents
  recoveryAgentCreate: base + '/recovery-agent/create', //POST
  recoveryAgentUpdate: base + '/recovery-agent/update', //PUT
  getRecoveryAgents: base + '/recovery-agent/', //GET
  getMeAsRaList: base + '/user/recovery-agent/', //GET
  finalizeRa: base + '/recovery-agent/finalizeRA', //POST
  recoveryAgentReject: base + '/user/recovery-agent/reject', //POST
  clocrRecoveryAgentReject: base + '/legacy-service/recovery-agent/reject', //PUT
  secreats: base + '/recovery-agent/EnrollSecret', //GET
  resendReq: base + '/recovery-agent/resent', //POST
  resendClocrReq: base + '/legacy-service/recovery-agent/resent', //PUT
  resendClocrRecoveryReq: base + '/legacy-service/recovery/resent', //PUT
  clientAppStatus: base + '/user/clientapp/status', //GET
  /** Published Secure Shell version + installer URLs (same source as desktop client). */
  cryptoClientDetails: base + '/user/crypto-client-details', //GET
  deleteRecoveryAgents: base + '/recovery-agent/delete?id=', //DELETE
  keyRecoverRequest: base + '/recovery-agent/SecretKeyRecoverRequest',
  /** /i-am-Trustee (trustee disbursement recovery) — POST /legacy/get-azure-token/self-kyc */
  scytaleKYC: base + '/legacy/get-azure-token/self-kyc',
  scytaleSelfKyc: base + '/legacy/get-azure-token/self-kyc',
  /** Secrets Vault initiate recovery — POST /legacy/get-azure-token */
  scytaleKycFromRecovery: base + '/legacy/get-azure-token',
  /** Trustee KYC — first enrollment after Scytale (isRecoveryFlow=false). */
  trusteeKycStore: base + '/legacy/trustee-kyc/store',
  /** Trustee KYC — revalidation against stored row (isRecoveryFlow=true). */
  trusteeKycVerify: base + '/legacy/trustee-kyc/verify',
  /** Trustee KYC — whether a STORED/VERIFIED row exists for trustee + owner (+ secret). */
  trusteeKycStatus: base + '/legacy/trustee-kyc/status',
  myRequestToRespond: base + '/user/secretKey/request', //GET
  /** Phase 3 — preferred RA list for delegate recovery (iamra / recovery agent dashboard) */
  raDelegateSecretKeyRequests:
    base + '/recovery-agent/toughbox/kyc/delegate/ra/secretKeyRequests', // GET
  raAgentInitiateRecovery:
    base + '/recovery-agent/toughbox/agent/initateAgentRecoveryRequest', // POST legacy self-recovery
  raUpdateRecoverSecretForDelegation:
    base + '/recovery-agent/toughbox/UpdateRecoverSecretForDelegation', // deprecated — use raDelegateApproveRecovery
  raDelegateApproveRecovery:
    base + '/recovery-agent/toughbox/kyc/delegate/ra/approveRecovery', // POST Tests 24–28
  /** Test 29 step A — delegate view secret (CompleteRecoverSecretWithDelegate endRecovery=false) */
  delegateViewRecovery:
    base + '/recovery-agent/toughbox/kyc/delegate/viewRecovery', // POST
  /** Test 29 step B — delegate complete recovery (CompleteRecoverSecretWithDelegate endRecovery=true) */
  delegateCompleteRecovery:
    base + '/recovery-agent/toughbox/kyc/delegate/completeRecovery', // POST
  /** Cancel / complete delegate recovery on Toughbox (POST body: { id, type: 'CANCEL' | 'COMPLETE' }) */
  completeRecoverSecretWithDelegate:
    base + '/recovery-agent/toughbox/CompleteRecoverSecretWithDelegate', // POST
  acceptSecretKeyRecovery: base + '/user/secretKey/accept', // POST
  updateKeyStatus: base + '/user/secretKey/status', // PUT — after view (legacy owner path)
  trusteeRecoveryStatus: base + '/recovery-agent/toughbox/user/recoveryStatus', // GET
  finalizeTrusteeRecovery: base + '/recovery-agent/toughbox/finalizeRecovery', // POST
  requestInitiatedResent: base + '/user/secretKey/resent', //POST
  rejectSecretRecoverRequest: base + '/user/secretKey/reject', //POST
  rejectSelfSecretRecoverRequest: base + '/legacy-service/recovery/reject', //PUT
  secretKeyDetails:
    base + '/recovery-agent/secretKeyDetails?recovery_agent_id=', //GET
  saveInheritance: base + '/user/inheritance', //POST
  saveInheritanceTrustee: base + '/user/trustee', //POST
  getContracts: base + '/user/inheritance', //GET
  deleteContract: base + '/user/inheritance', // DELETE
  updateContract: base + '/user/inheritance', //PUT
  updateTrusteeEmail: base + '/user/trustee', // PUT DELETE
  getSecretValutDashboardData: base + '/user/secretKey/dashboard', //GET
  thersholdCount: base + '/user/thershold', //GET
  agreeVaultAgreement: base + '/user/agreement', //PUT
  getWillData: base + '/cryptowill', //GET
  deleteExecutor: base + '/cryptowill/executor', //DELETE
  deleteNominee: base + '/cryptowill/nominees', //DELETE
  saveBenificiaries: base + '/cryptowill/nominees/bulk', //POST
  saveWallet: base + '/cryptowill/wallet', //PUT
  createDisbursementRequest: base + '/disbursement/crypto', //POST — returns data.approval { required, initiatorIsPrimary, primaryTrusteeIds }
  getDisbursementRequests: base + '/disbursement/crypto', //GET
  /** Owners you serve as trustee — GET `/disbursement/crypto/frozen/trustee?dbName=` */
  getFrozenTrusteeDisbursements: base + '/disbursement/crypto/frozen/trustee', //GET
  getDisbursementReasons: base + '/startup/getAllDisbursementReasons', //GET
  getDisbursementUsers: base + '/disbursement/users', //GET
  getDisbursementNotes: base + '/disbursement/crypto/', //GET
  saveDisbursementNotes: base + '/disbursement/crypto/', //POST
  saveDisbursementFiles: base + '/disbursement/crypto/doc/', //POST
  getDisbursementFiles: base + '/disbursement/crypto/doc/', //GET
  getAllDisbursementRequests: base + '/disbursement/crypto/request', //GET
  /** Only Primary Trustee when initiator was not Primary; Primary-initiated is auto-accepted at create */
  acceptDisbursementRequest: base + '/disbursement/crypto/accept', //PUT
  rejectDisbursementRequest: base + '/disbursement/crypto/reject', //PUT
  getAdminDisbursementFiles: base + '/admin/crypto/doc/', //GET
  getAdminDisbursementRequests: base + '/admin/crypto/disbursement', //GET
  /** Blocked until Primary Trustee accepted (unless initiator was Primary) */
  approveAdminDisbusementRequest: base + '/admin/crypto/disbursement/approve', //PUT
  rejectAdminDisbursementRequest: base + '/admin/crypto/disbursement/reject', //PUT { id, reason }
  reviewAdminDisbusementRequest: base + '/admin/crypto/disbursement/review', //PUT
  /** Admin / delegation admin — cancel disbursement + reset recovery */
  cancelAndResetAdminDisbursement:
    base + '/admin/delegation-admin/disbursement/cancel-and-reset', // POST ?dbName= { id, reason }
  confirmAdminDisbursementDeceased:
    base + '/admin/crypto/disbursement/confirm-deceased', // POST { disbursementId }
  freezeAdminDisbursementAccount:
    base + '/admin/crypto/disbursement/freeze-account', // POST { id, vaultFreezeRef, newstate }
  listAdminFrozenDisbursementAccounts:
    base + '/admin/crypto/disbursement/frozen-accounts', // GET — delegation admin JWT
  getAdminAdvisors: base + '/admin/advisors', //GET
  businessUserApprove: base + '/admin/businessUserApprove', //POST { email }
  adminAdvisorCredits: base + '/admin/advisor-credits', //GET
  adminAdvisorCreditsGrant: base + '/admin/advisor-credits', //POST /:associateId/grant
  markAsReadyForDisbursement:
  base + '/admin/crypto/disbursement/ready-for-disbursement', //PUT
  getDisbursementDetails: base + '/admin/crypto/disbursement/request', //PUT
  getDisbursementRecordDetails: base + '/admin/crypto/disbursement/details', //GET
  saveOnboardingInformation: base + '/user/useronboarding', //PUT
  resetRecovery: base + '/recovery-agent/toughbox/resetRecovery', //POST
  delegateResetRecovery:
    base + '/recovery-agent/toughbox/delegate/resetRecovery', //POST
  /** Enrollment record for Toughbox recovery (trustee: accessType=TRUSTEE&targetUserId=) */
  getEnrollmentRecord: base + '/user/recovery-request/enrollData', //GET
  /** Delegate disbursement recovery enrollData — sessionID in tough_box_request_json */
  disbursementRecoveryEnrollData:
    base + '/recovery-agent/toughbox/disbursement/enrollData', // GET ?id=&ownerId=
  /** Store incomplete StartRecoveryRecord from client */
  finalizeRequest: base + '/recovery-agent/toughbox/initateUserRecoveryRequest', //POST
  /** Test 21 — disbursement delegate USB Toughkey (Toughbox CreateToughkey proxy) */
  createDisbursementDelegateToughkey:
    base + '/recovery-agent/toughbox/disbursement/createToughkey', // POST ?dbName=&targetUserId=&delegateId=&disbursementId= body: { serialNumber, username: delegateId, group }
  /** Delegate disbursement — Toughbox StartRecoverSecretWithDelegate (client → backend proxy) */
  startRecoverSecretWithDelegate:
    base + '/recovery-agent/toughbox/startRecoverSecretWithDelegate', // POST
  /** After StartRecoverSecretWithDelegate — ?ownerId=&disbursementId= */
  initateDisbursementTrusteeRecoveryRequest:
    base + '/recovery-agent/toughbox/initateDisbursementTrusteeRecoveryRequest', // POST
  initiateKeyDeviceId: base + '/recovery-agent/key_device', //POST
  getTimeLineData: base + '/disbursement/crypto/audit', //GET
  // updateClientAppStatus: base+'/user/clientapp/status', //PUT
  //contacts
  contacts: base + '/caretaker', //GET DELETE POST
  setRole: base + '/user/role', //PUT
  dashboard: base + '/user/secretKey/dashboard/v1', //GET
  clients: base + '/cryptowill/beneficiary/clients', //GET
  willDetails: base + '/cryptowill/beneficiary/wills', //GET
  allWills: base + '/cryptowill/beneficiary/wills/all', //GET
  trusteeClients: base + '/user/trustee/clients', //GET
  vault: base + '/user/trustee/vaults', //GET
  allVaults: base + '/user/trustee/vaults/all', //GET
  userExists: base + '/user/exists', //POST
  register: base + '/user/registerUser', //POST PUT
  subscriptionList: base + '/crypto/payment/products', //GET
  kycList: base + '/crypto/payment/kyc/products', //GET
  kycDetails: base + '/crypto/payment/kyc/details', //GET
  creditLimit: base + '/crypto/payment/creditLimit', //GET
  dlsvCreditLimit: base + '/legacy/dlsv/creditLimit', //GET
  stripeSession: base + '/crypto/payment/stripeSession', //POST
  stripeSessionKyc: base + '/crypto/payment/kyc/stripeSession', //POST
  timezone: base + '/user/timezone', //PUT
  cancelSubscription: base + '/crypto/payment/cancelSubscription', //POST
  resumeSubscription: base + '/crypto/payment/resumeSubscription',
  legacyCancelSubscription: base + '/legacy/cancelSubscription', //POST
  legacyResumeSubscription: base + '/legacy/resumeSubscription', //POST
  legacyDigitalCancelSubscription: base + '/legacy/digital/subscription/cancel', //POST
  legacyDigitalResumeSubscription: base + '/legacy/digital/subscription/resume', //POST
  subscriptionHistory: base + '/crypto/payment/subscriptionHistory', //GET
  legacySubscriptionHistory: base + '/legacy/subscription-history', //GET
  checkDevicePermission: base + '/recovery-agent/ra_device/verify', //POST
  deleteSecretKey: base + '/user/secret_vault', //DELETE
  trusts: base + '/user/trust', //GET PUT POST DELETE
  getSelfRecoveryKeys: base + '/legacy-service/keys', //GET
  emergencyBinder: base + '/user/emergencyBinder', //GET
  createRA: base + '/legacy-service/recovery-agent/create', //POST
  getRAs: base + '/legacy-service/recovery-agent', //GET
  getRecoveryGuardian: base + '/legacy/recovery-agent/request', //GET
  getSelfSecretRequests: base + '/legacy-service/recovery/request', //GET
  cancelRecoveryRequest: base + '/legacy-service/cancelRecovery', //PUT
  updateSecretRecoverStatus:
    base + '/recovery-agent/toughbox/kyc/initateUserRecoveryRequest', // GET
  initateAdminVerifyPendingRecoveryRequest:
    base +
    '/recovery-agent/toughbox/kyc/admin-verify-pending/initateUserRecoveryRequest', // POST
  getRewards: base + '/user/reward-points', //GET
  getWalletIFrameUrl: base + '/user/getfront-api/iframe-url', //GET
  getAccountHoldings: base + '/user/getfront-api/data', //GET
  brokerInfo: base + '/cryptowill/broker', //GET, POST
  updateClientAppStatus: base + '/user/client/update', // GET
  getPromoDetails: base + '/startup/mylegacy/getPromoText', // GET

  //my legacy routes
  familyBundle: base + '/legacy/familybundle', //POST
  houseHoldDetails: base + '/legacy/houseHold',
  legacyInfo: base + '/legacy/legacyInfo',

  // Legacy Score v2
  legacyScoreEvaluate:        baseV2 + '/legacy-score/evaluate',         // POST — no auth
  legacyScoreProfile:         baseV2 + '/legacy-score/profile',          // POST — commit profile (auth)
  legacyScoreCurrentProfile:  baseV2 + '/legacy-score/profile/current',  // GET  — re-intake pre-pop (auth)
  legacyScoreScore:           baseV2 + '/legacy-score/score',            // GET  — dashboard score (auth)
  legacyScoreDocuments:       baseV2 + '/legacy-score/documents',        // GET  — doc list (auth)
  legacyScoreDiff:            baseV2 + '/legacy-score/diff',             // POST — preview diff (auth)
  legacyScoreCommit:          baseV2 + '/legacy-score/commit',           // POST — apply diff (auth)
  legacyScoreDocStatus:       (docId: string) => baseV2 + `/legacy-score/documents/${docId}/status`, // PATCH (auth)
  legacyScoreDocMyList:       (docId: string) => baseV2 + `/legacy-score/documents/${docId}/my-list`, // PATCH (auth)
  legacyScoreCheckoutSession: baseV2 + '/legacy-score/checkout-session',   // POST — no auth (guest checkout)
  legacyScoreCheckoutSessionMine: baseV2 + '/legacy-score/checkout-session/me', // POST — auth (Dashboard v2 upgrade)
  legacyScoreVerifySession:   (sessionId: string) => baseV2 + `/legacy-score/checkout-session/${sessionId}`, // GET — no auth
  legacyScoreEmailReport:     baseV2 + '/legacy-score/email-report',       // POST — no auth
  legacyScoreReminders:       baseV2 + '/legacy-score/reminders',          // POST — no auth
  legacyScoreRemindersGet:    (sessionId: string) => baseV2 + `/legacy-score/reminders/${sessionId}`, // GET — no auth
  legacyScoreRemindersMine:   baseV2 + '/legacy-score/reminders/me',       // POST/GET — auth (Dashboard v2)
  legacyScoreMyPlan:          baseV2 + '/legacy-score/purchases/me',       // GET — auth (Dashboard v2 plan gating)
  legacyScoreGenerationsStart:  baseV2 + '/legacy-score/generations',        // POST — no auth
  legacyScoreGenerationsUpdate: (tempId: string) => baseV2 + `/legacy-score/generations/${tempId}`, // PATCH — no auth
  legacyScoreCounter:          baseV2 + '/legacy-score/counter',           // GET — no auth
  legacyScoreCounterIncrement: baseV2 + '/legacy-score/counter/increment', // POST — no auth
  legacyScoreCheckUser:        baseV2 + '/legacy-score/check-user',        // POST — no auth
  legacyScoreRegisterGuest:    baseV2 + '/legacy-score/register-guest',    // POST — no auth
  termsConInfo: base + '/legacy/terms_con',
  surveyQuestions: base + '/legacy/survey-questions', //GET //POST
  myLegacyActionItems: base + '/legacy/get-my-legacy-actions', //GET
  myLegacyUserActionItems: base + '/legacy/get-user-actions', //GET
  addUserActionItems: base + '/legacy/add-user-action', //POST
  removeUserActionItems: base + '/legacy/remove-user-action', //POST

  personalRecommendations: base + '/legacy/show-personal-recommendations', //GET
  legacyPaymentProducts: base + '/legacy/products/', //GET
  askQuestion: base + '/legacy/chat', //POST
  askQuestionNew: base + '/legacy/chat-v2',
  askQuestionUnregistered: base + '/legacy/chat/unregistered',
  getUserInterest: base + '/legacy/get-user-interest',
  saveUserInterest: base + '/legacy/save-user-interest',
  createStripeSession: base + '/legacy/digital/createStripeSession',
  createSignupStripeSession: base + '/legacy/digital/signup/createStripeSession', 
  createLifetimeStripeSession: base + '/legacy/new/digital/createLifetimeStripeSession',
  secretVaultBuy: base+ '/crypto/payment/stripeSession',
  manualSub: base+ '/legacy/manual/subscription',
  initiateChat: base + '/legacy/initiate-chat',
  buyChatbotCreditsStripe: base + '/legacy/chatbot/createStripeSession',
  createKycStripeSession: base + '/legacy/kyc/createStripeSession',
  updateKycStripeSession: base + '/legacy/kyc/updateStripeSession',

  //will
  createWill: base + '/user/will', //POST
  getWill: base + '/user/will', //GET

  // Payment Legacy
  getPaymentProducts: base + '/legacy/products', //GET
  getStripeSession: base + '/legacy/stripeSesssion', //POST

  //creditcardLimit
  getCreditLimit: base + '/legacy/creditLimit', //GET
  createUserReferal: base + '/user/user-refferal', //POST,

  fileCategories: base + '/legacy/file/category', //GET // POST // PUT // DELETE
  fileVaultAddFile: base + '/legacy/file/add', // POST
  fileVaultGetFiles: base + '/legacy/file/list', // POST
  fileVaultFile: base + '/legacy/file',
  fileIce: base + '/legacy/file/ice', // POST

  isEmailReferred: base + '/user/check-referee-email',
  applyPromoCode: base + '/legacy/apply-credits',

  getUserIpDetails: base + '/legacy/user-ip',
  createNewUserSession: base + '/legacy/create-new-session',

  getIceContact : base + '/legacy/contacts',

  // shared with me
  getSharedModules: base + '/legacy/shared-with-modules',
  getModuleData: base + '/legacy/list-module-files',
  shareNewFile: base + '/legacy/save-shared-file',
  getSharedWithMeFiles: base + '/legacy/get-shared-with-me',
  deleteSharedAsset: base + '/legacy/delete-shared-file',
  updateSharedFile: base + '/legacy/update-shared-file',

  //emergencyVault - assetportpolio ice 
  updateAssetIce : base + '/legacy/asset/portfolio/iceVault' , 
  getAssetDetails: base + '/legacy/emergency-vault/assets',
  getSharedcontacts: base + '/legacy/shared-with-me/contacts',
  getSharedMeFile: base + '/legacy/shared-with-me/files',
  //GET DELETE POST

  //update Emergency Conatct
  updateEContact : base + '/caretaker/ecUpdate',

  // Emergency Binder
  getEmergencyBinder: base + '/legacy/getEmergencyBinder', //GET
  createEmergencyBinder: base + '/legacy/createEmergencyBinder', //GET
  setEmergencybinderQuorum: base + '/legacy/setEmergencybinderQuorum', //POST
  openEmergencyBinder: base + '/legacy/openEmergencybinder', //POST
  closeEmergencyBinder: base + '/legacy/closeEmergencybinder', //POST
  getEmergencyBinderAuditTrail: base + '/legacy/getEmergencyBinderAuditTrail', //GET
  getEmergencyBinderOpenRequests: base + '/legacy/getEmergencyBinderOpenRequests', //GET
  approveEmergencyBinderOpenRequest: base + '/legacy/approveEmergencyBinderOpenRequest', //POST

  // online accounts 
  onlineAccounts: base + '/legacy/onlineAccount', // GET
  sources: base + '/legacy/onlineAccountsources', // GET
  exportAccounts :  base + '/assets/estatePlanXslxFormat', // POST
  AddExportAccounts :  base + '/legacy/onlineAccount/bulk/add',
  bulkDeleteAccounts :  base + '/legacy/onlineAccount/bulk/delete',
  //for inheritance
  addDirective : base + '/legacy/addInheritance',
  getInheritanceDirective : base + '/legacy/inheritance',
  finalizeInheritance: base + '/legacy/inheritance/finalize',
  listInhSecKey: base +'/legacy/inheritance/secretKey',
  allInhSecKey: base +'/legacy/inheritance/secretKey/all',
  OAdirective : base + '/legacy/directive',

  // New Agent APIS
  agentStream: base + '/legacy/agent/stream', // POST
  agentHealth: base + '/legacy/agent/health', // GET
  agentSQL: base + '/legacy/agent/sql', // POST
  agentFeedback: base + '/legacy/agent/feedback', // POST

  // Account delete post & get
   accountDelete: base + '/user/account/deletion-request',
   accountDeleteList: base + '/user/account/deletion-request-list',
   cancelDeleteAccount : base + '/user/account/deletion-request-cancel',

  // Trustee request list
   trusteeRequestList: base + '/legacy/trusteeRequestList', //GET
   trusteeRequestUpdate: base + '/legacy/trusteeRequestUpdate', //PUT
   trusteeRequestDetails: base + '/legacy/trusteeRequest/details', //GET
   imaTrustee: base + '/legacy/imatrustee', //GET
   trusteeReminder: base + '/legacy/trusteeReminder', //POST

  // Azure token standalone KYC
   azureTokenStandalone: base + '/legacy/azure-token/standalone', //POST

  // Business User APIs
  registerBusinessUser: base + '/business/registerUser', //POST
  getBusinessTypes: base + '/business/businessTypes', //GET
  // Align with clocr-frontend business_user routes (base already includes /api/v1 here)
  businessUserLogin: base + '/business/new/login', //POST
  businessUserVerifyOTP: base + '/business/new/verifyOTP', //POST
  businessUserForgotPassword: base + '/business/forgotPassword', //POST
  businessUserResendOTP: base + '/business/resendOTP', //POST
  getBusinessUserDetails: base + '/business/getUserDetails', //GET
  businessVerifyPassword: base + '/business/verifyPassword', //POST
  businessSavePassword: base + '/business/savePassword', //POST
  buVerifySetPassword: base + '/business/verifySetPassword', //POST

  // Business Onboarding / Company
  buCreateCompany: base + '/business/createCompany', //PUT
  buGetCompany: base + '/business/getCompanyDetails', //GET
  buClientVisibility: base + '/business/clientVisibility', //PUT — admin only
  buUpdateCompany: base + '/business/editCompany', //PUT
  buCompanyLogo: base + '/business/uploadLogo', //POST
  deleteCompanyProfile: base + '/business/deleteLogo', //DELETE
  buVerification: base + '/business/verification', //PUT
  buCustomTemplate: base + '/business/template', //GET & POST

  // Business lists (clocr-frontend style)
  buGetOffices: base + '/business/getOfficeList', //GET
  buGetAssociates: base + '/business/getAssociateList', //GET
  buGetClients: base + '/business/getClients', //GET
  buCreateOffice: base + '/business/createOffice', //PUT
  businessOnboardingStatus: base + '/business/onboarding', // POST (final completion)
  // Business associates
  buCreateAssociate: base + '/business/addAssociate', //PUT
  buGetAssociateDetails: base + '/business/getAssociateDetails', //GET
  buUpdateAssociate: base + '/business/editAssociate', //PUT
  buDeleteAssociate: base + '/business/deleteAssociate', //DELETE
  buResendAssociateRequest: base + '/business/resendAssociateRequest', //POST /:associateId
  /** Public (no session) — GET company list for associate self-registration */
  buCompaniesList: base + '/business/companies', //GET
  /** Public (no session) — POST { email, firstName, lastName, companyId } */
  buRegisterAssociate: base + '/business/registerAssociate', //POST
  buGetBusinessUser: base + '/business/getUserDetails', //GET
  buAssociateProfile: base + '/business/profilePic', //POST
  deleteBusinessuserProfile: base + '/business/deleteProfilePic', //DELETE

  // Business clients
  buCreateClient: base + '/business/createClients', //PUT
  /** POST body `{ email, countryId?, stateId? }` — connect a single customer (post report-generation) to the calling associate. */
  /** Starts a legacy_score_generations row attributed to this associate — call before running a report. */
  buLegacyScoreSessionStart: base + '/business/legacyScoreSession', //POST
  buLegacyScoreCredits: base + '/business/legacyScoreCredits', //GET
  buLegacyScoreCreditsConsume: base + '/business/legacyScoreCredits/consume', //POST
  buConnectClient: base + '/business/connectClient', //POST
  /** GET `?email=` — subject/body the associate can copy, for an already-connected client. */
  buClientReportEmailPreview: base + '/business/clientReportEmail/preview', //GET
  /** POST body `{ email }` — send that same email to the client from the system. */
  buClientReportEmailSend: base + '/business/clientReportEmail/send', //POST
  buUpdateClient: base + '/business/updateClients', //PUT
  buRemoveClient: base + '/business/removeClient', //DELETE
  /** POST body `{ clientId }` — query `?dbName=` required for multi-tenant. */
  buResendClientRegistrationEmail: base + '/business/resendClientRegistrationEmail', //POST
  getBusinessClients: base + '/business/clients', //GET
  getBusinessAdvisors: base + '/business/advisors', //GET
  getBusinessOffices: base + '/business/offices', //GET
  getOfficeList: base + '/business/getOfficeList', //GET
  getAssociateList: base + '/business/getAssociateList', //GET
  getBusinessDashboard: base + '/business/getCompanyDashboard', //GET
  createOffice: base + '/business/createOffice', //POST
  updateOffice: base + '/business/editOffice', //PUT
  deleteOffice: base + '/business/deleteOffice', //DELETE
  getOfficeDetails: base + '/business/getOfficeDetails', //GET

  // Business B2B Marketplace
  buBusinesscard: base + '/business/businessCard', //POST
  buGetSkillsForAdvisor: base + '/business/advisorCategories', //GET PUT
  buGetAdvisorSubCategory: base + '/business/advisorSubCategories', //GET
  buPutAdvisorServiceLocations: base + '/business/advisorStates', //PUT

  // Business Client Checklist
  buGetClientChecklist: base + '/business/getClientsCheckList', //POST
  onboardingDetailsnav: base + '/onboard/menus', //GET

  // Business Client Management
  getPermissionsByClient: base + '/business/client-permission-details', //GET
  
  // User Permissions
  getUserPermissions: base + '/user/permissions', //GET
  // User Clients (for regular users to get their advisors/clients for Advisor Access)
  getAllBusinessOfClient: base + '/user/business/listClients', //GET - Get all businesses/advisors for client
  getSpecificBusinessPermissions: base + '/user/business/client', //GET - Get permissions for specific business
  updatePermissionsByClient: base + '/user/business/updateClient', //PUT - Update permissions

  // Time Capsule APIs
  timeCapsuleCount: base + '/timeCapsule/dashboard',
  timeCapsuleDetailview: base + '/timeCapsule/dashboard/',
  timeCapsuleAddEvent: base + '/timeCapsule/event/add',
  timeCapsuleEditEvent: base + '/timeCapsule/event/edit',
  timeCapsuleDeleteEvent: base + '/timeCapsule/event/delete/',
  timeCapsuleEventUser: base + '/timeCapsule/event_users/add',
  timeCapsuleDeleteUser: base + '/timeCapsule/event_users/delete/',
  timeCapsuleAddDocument: base + '/timeCapsule/event_docs/add/',
  timeCapsuleDeleteDocument: base + '/timeCapsule/event_docs/delete/',
  timeCapsuleDownloadDocument: base + '/timeCapsule/event_docs/view/',
  timeCapsuleUploadVideo: base + '/timeCapsule/event_docs/add/video/',
  timeCapsuleGetCareTaker: base + '/caretaker/',
  timeCapsuleGetCareTakerOfAssets: base + '/legacy/getCateTakerOfAssets',
};
